/**
 * @generated SignedSource<<a9a56ff6fdb3a10a4d30d97c3bca1d27>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SkillResult = "ALMOST_THERE" | "DEMONSTRATED" | "KEEP_LEARNING" | "NOT_STARTED" | "PASSED" | "PLACED_OUT" | "REVIEW" | "%future added value";
export type SkillsProgressReportFilterInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  gradeLevelIds?: ReadonlyArray<string> | null | undefined;
  isActive?: boolean | null | undefined;
  skillIds: ReadonlyArray<string>;
};
export type SkillsResultsReportQuery$variables = {
  filter: SkillsProgressReportFilterInput;
  skip?: boolean | null | undefined;
};
export type SkillsResultsReportQuery$data = {
  readonly skillsProgressReport?: ReadonlyArray<{
    readonly skill: {
      readonly id: string;
    };
    readonly skillsResults: ReadonlyArray<{
      readonly key: SkillResult;
      readonly value: number;
    }>;
  }>;
};
export type SkillsResultsReportQuery = {
  response: SkillsResultsReportQuery$data;
  variables: SkillsResultsReportQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
          }
        ],
        "concreteType": "SkillReportProgress",
        "kind": "LinkedField",
        "name": "skillsProgressReport",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillNode",
            "kind": "LinkedField",
            "name": "skill",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "KeyValuePairOfSkillResultAndInt32",
            "kind": "LinkedField",
            "name": "skillsResults",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SkillsResultsReportQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SkillsResultsReportQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "798c040e3d3d132d5298549158c19b68",
    "id": null,
    "metadata": {},
    "name": "SkillsResultsReportQuery",
    "operationKind": "query",
    "text": "query SkillsResultsReportQuery(\n  $filter: SkillsProgressReportFilterInput!\n  $skip: Boolean = false\n) {\n  skillsProgressReport(filter: $filter) @skip(if: $skip) {\n    skill {\n      id\n    }\n    skillsResults {\n      key\n      value\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f4729a5393aacb6b795f941831ce0b6c";

export default node;
